import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
// import { allapiAction } from "../../../Redux/common/action";
// import { URL } from "../../../Redux/common/url";
// import Footer from "../Layout/Footer";
// import Header from "../Layout/Header";
// import Sidebar from "../Layout/Sidebar";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import moment from "moment";

import ImageUploading from "react-images-uploading";
import { toast } from "react-toastify";
// import dateFormat, { masks } from "dateformat";

import ReactToPrint from "react-to-print";
// import { allapiAction } from "@/Redux/common/action";
// import { URL } from "@/Redux/common/url";
// import Header2 from "../../../component/sidebar/Header2";
// import Sidebar from "../../../component/sidebar/Sidebar";
// import { ExportToExcel } from "../../../component/ExportToExcel";
import { allapiAction } from "../../Redux/common/action";
import { ExportToExcel } from "../ExportToExcel";
import Sidebar from "../Layout/Sidebar";
import HeaderAccount from "../Layout/HeaderAccount";
import Chart from "react-google-charts";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AllTeamApp2 from "./AllTeamApp2";
import SignUplistTab from "./SignUplistTab";
function TeamBoardTab() {
  const [teamboarddata, setteamboarddata] = useState("team-board");

  return (
    <div>
      <Sidebar />

      <main className="main-wrap ">
        <HeaderAccount />

        <section className="content-main">
          <div className="AppPro">
            <div className="CategoryListapp">
              <div class="">
                <div class="d-flex justify-content-around mb-3 cateLi">
                  <button
                    onClick={() => {
                      setteamboarddata("team-board");
                    }}
                    // class={"tab-btn btn btn-light fts"}
                    class={
                      teamboarddata === "team-board"
                        ? "fts tab-btn btn btn-light active"
                        : "tab-btn btn btn-light fts"
                    }
                  >
                    {/* <img
                              src={URL?.API_BASE_URL + data?.image}
                              alt={data?.name}
                            /> */}
                    {/* {data?.name} */}
                    Team Board
                  </button>
                  <button
                    onClick={() => {
                      setteamboarddata("sign-up-team");
                    }}
                    // class={"tab-btn btn btn-light fts"}
                    class={
                      teamboarddata === "sign-up-team"
                        ? "fts tab-btn btn btn-light active"
                        : "tab-btn btn btn-light fts"
                    }
                  >
                    {/* <img
                              src={URL?.API_BASE_URL + data?.image}
                              alt={data?.name}
                            /> */}
                    {/* {data?.name} */}
                    Signup Team
                  </button>
                </div>
              </div>
            </div>
          </div>

        { teamboarddata === "team-board" && <AllTeamApp2 />}
        { teamboarddata === "sign-up-team" && <SignUplistTab />}
        </section>
      </main>
    </div>
  );
}

export default TeamBoardTab;
